/**
 * Produce the union of two sets.
 */
export function union<T>(left: Set<T>, right: Set<T>): Set<T> {
	return new Set<T>([...left, ...right]);
}

/**
 * Produce the intersection of two sets.
 */
export function intersection<T>(left: Set<T>, right: Set<T>): Set<T> {
	return new Set<T>([...left].filter((v) => right.has(v)));
}

/**
 * Produce the difference of two sets (left - right).
 */
export function difference<T>(left: Set<T>, right: Set<T>): Set<T> {
	return new Set<T>([...left].filter((v) => !right.has(v)));
}

/**
 * Determine set right is a subset of set left.
 */
export function isSubset<T>(left: Set<T>, right: Set<T>): boolean {
	return [...right].every((v) => left.has(v));
}
